import { Component, Input, OnInit } from '@angular/core';
import { hasIn } from 'lodash';
import { ConsumerPlanV2, EligibilityType, PlanRecurrenceType, Speed, TrafficConfig, TrafficLabelId } from 'src/app/core';
import { DataControlType } from 'src/app/dashboard/mobile/plans/enums';

@Component({
  selector: 'app-plan-summary',
  templateUrl: './plan-summary.component.html',
  styleUrls: ['./plan-summary.component.less']
})
export class PlanSummaryComponent implements OnInit {
  @Input() isGrantPlanFormType: boolean = false;
  isPlanV1: boolean = false;
  generalCapacity: number = 0;
  DataControlType = DataControlType;
  EligibilityType = EligibilityType;
  PlanRecurrenceType = PlanRecurrenceType;
  eligibilityStyle = {
    ELIGIBLE_TO_QUEUE: 'warning',
    ELIGIBLE_TO_ACTIVATE: null,
    ELIGIBLE_TO_PREPROVISION: null,
    ELIGIBLE_TO_ADD_PAYMENT: 'success',
    NOT_ELIGIBLE: null,
  };
  private _plan: ConsumerPlanV2;

  get plan(): ConsumerPlanV2 {
    return this._plan;
  }

  @Input() set plan(plan: ConsumerPlanV2) {
    this._plan = plan;

    if (plan) {
      this.isPlanV1 = hasIn(this.plan, 'planUuid');
      this._setGeneralCapacity(plan);
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

  private _setGeneralCapacity(plan: ConsumerPlanV2): void {
    const generals = plan.trafficLabels.filter((trafficLabel: TrafficConfig) => {
      return trafficLabel.trafficLabelId === TrafficLabelId.GENERAL;
    });

    // Use SPEED_MAX if multiple trafficLabel with the same trafficLabelIds are being used
    let general = null;
    if (generals.length > 1) {
      general = generals.find((trafficLabel: TrafficConfig) => {
        return trafficLabel.speed === Speed.SPEED_MAX;
      });
    } else {
      general = generals[0];
    }

    if (general) {
      this.generalCapacity = general.capacity;
    }
  }

}
